import { xMinValue } from './xMinValue';
import { xRolling } from './xRolling';
/**
 * This function calculates a minimum within a rolling window
 *
 * @param array - the array that will be rotated
 * @param options - options
 */
export function xRollingMin(array, options = {}) {
    return xRolling(array, xMinValue, options);
}
//# sourceMappingURL=xRollingMin.js.map